var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-radio-group',{staticClass:"navigation__tabs",attrs:{"size":"mini"},model:{value:(_vm.pageTab),callback:function ($$v) {_vm.pageTab=$$v},expression:"pageTab"}},_vm._l((_vm.tabs),function({ key, label, name }){return _c('el-radio-button',{key:key,staticClass:"navigation__tabs__item",attrs:{"label":label}},[_vm._v(" "+_vm._s(name)+" ")])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }